import * as React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import { setCredentials } from './Cookies';
import Alert from '@mui/material/Alert';
import { Navigate } from "react-router-dom";
import { connect, signUp, create_recovery_link } from './Network';
import { getSentence, getLanguage } from './translations';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { matomoEvent, matomoTracker } from './matomoTracker';

const defaultTheme = createTheme();



export class SignIn extends React.Component 
{

    constructor()
    {
        super();

        this.state = {
            mail: "",
            passwd: "",
            tab: 0,
            mailError: "",
            passwdError: "",
            mailHelperText: "",
            passwdHelperText: "",
            errorMsg: "",
            recoveryPasswdDialog: "",
            TOSState: false,
            TOSError: false,
            TOSHelperText: ""
        }    

        this.CustomTabPanel.propTypes = {
            children: PropTypes.node,
            index: PropTypes.number.isRequired,
            value: PropTypes.number.isRequired,
          };
        
        this.changeTab = this.changeTab.bind(this);
        this.checkMail = this.checkMail.bind(this);
        this.handleSignUp = this.handleSignUp.bind(this);
        this.handleSignIn = this.handleSignIn.bind(this)
        this.changeTOSState = this.changeTOSState.bind(this)


        this.delay = ms => new Promise(
            resolve => setTimeout(resolve, ms)
          );
    }

    async componentDidMount() 
    {
        matomoTracker();
    }


    recoveryPasswdDialog()
    {
        var actions = ""
    
        actions = <DialogActions>
                    <Button onClick={()=>{this.setState({recoveryPasswdDialog: ""})}}>{getSentence(8)}</Button>
                    <Button onClick={async ()=>{
                        const response = await create_recovery_link(document.getElementById("recoveryEmail").value)
                        if (response == 200){
                            this.setState({recoveryPasswdDialog : <Alert severity="success">
                                {getSentence(58) + " " + document.getElementById("recoveryEmail").value}
                            </Alert>})
                        }
                        else{//might be usefull to have a specific error code for email non existing in the db.
                            this.setState({recoveryPasswdDialog : <Alert  severity="error">
                                    {getSentence(59)}
                            </Alert>})
                        }
                    }}>{getSentence(9)}</Button>
                </DialogActions>


       var dialog = <Dialog
                        open={true}
                        onClose={()=>{this.setState({recoveryPasswdDialog: ""})}}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullWidth={true}
                        maxWidth="md"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {getSentence(57)}
                        </DialogTitle>
                        <DialogContent>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="recoveryEmail"
                                label={getSentence(23)}
                                name="email"
                                autoComplete="email"
                                autoFocus
                                defaultValue={this.state.mail}
                                onBlur={event => this.checkMail(event.target.value)}
                                error = {this.state.mailError}
                                helperText={this.state.mailHelperText}
                            />
                        </DialogContent>
                        {actions}
                    </Dialog>

        this.setState({recoveryPasswdDialog: dialog})
}



    async changeTab(event, newValue)
    {
        const newPage =  newValue == 1 ? "signup" : "signin";
        matomoEvent('login - signin change tab', "web", newPage );
        this.setState({ tab: newValue});
        this.setState({mailError: false})
        this.setState({passwdError: false})
        this.setState({mailHelperText: ""})
        this.setState({passwdHelperText: ""})
    };

    
    CustomTabPanel(props) {
        const { children, value, index, ...other } = props;
      
        return (
          <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
          >
            {value === index && (
              <Box sx={{ p: 3 }}>
                <Typography>{children}</Typography>
              </Box>
            )}
          </div>
        );
      }
    
      a11yProps(index) {
        return {
          id: `simple-tab-${index}`,
          'aria-controls': `simple-tabpanel-${index}`,
        };
      }
    

    changeTOSState()
    {
        if (this.state.TOSState){
            this.setState({ TOSState: false});
        }
        else{
            this.setState({ TOSState: true});
        }

    }

    async handleSignUp(event)
    {
        event.preventDefault();
        const data = new FormData(event.currentTarget);

        const validMail = this.checkMail(data.get("email"))
        if (!this.state.TOSState)
        {
            this.setState({ TOSError: true});
            this.setState({ TOSHelperText: <p style={{color:'red'}}>{getSentence(73)}</p>});
        }
        else if (! validMail)
        {
            this.setState({ mailError: true});
            this.setState({ mailHelperText: getSentence(16)});
        }

        else if (data.get("password") === "" || data.get("password") !== data.get("passwordCheck"))
        {
            this.setState({ passwdError: true});
            this.setState({ passwdHelperText: getSentence(17)});
        }
        else
        {
            const response = await signUp(data.get("email"), data.get("password"))

            if (response === "account created")
            {
                setCredentials(data.get("email"), data.get("password"), false);
                matomoEvent('account created', "web", data.get("email"));
                this.setState({ errorMsg: <Navigate to="/" replace={true} />});//set replace to false if we want to allow to get back to the page by using the backarrow.
            }
            else
            {
                const errormsg = <Alert severity="error">{response}</Alert>
                this.setState({ errorMsg: errormsg});
            }
        }
    };


    async handleSignIn(event) 
    {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        
        const validMail = this.checkMail(data.get("email"))
        
        if (! validMail)
        {
            this.setState({ mailError: true});
            this.setState({ mailHelperText: "Please use a valid email."});
        }
        else if (data.get("password") === "")
        {
            this.setState({ passwdError: true});
            this.setState({ passwdHelperText: "Please enter your password."});
        }
        else
        {
            const response = await connect(data.get("email"), data.get("password"))
            
            if (response === "connected")
            {
                var remembber = false
                if (data.get("Remember me")){
                    remembber = true
                }
                setCredentials(data.get("email"), data.get("password"), !remembber);
                matomoEvent('connexion', "web", data.get("email"));
                this.setState({ errorMsg: <Navigate to="/" replace={true} />});
            }
            else
            {
                const errormsg = <Alert severity="error">{response}</Alert>
                this.setState({ errorMsg: errormsg});
            }
        }
        
    };


    checkMail(mail)
    {
        // from stackoverflow without any explanation.
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (mail !== "" && ! re.test(mail) ) //if not a valid mail format.
        {
            this.setState({ mailError: true});
            this.setState({ mail: mail});
            this.setState({ mailHelperText: "Please use a valid email."});
        }
        else
        {
            this.setState({ mailError: false});
            this.setState({ mail: mail});
            this.setState({ mailHelperText: ""});
            if (mail === ""){
                return false;
            }
            return true;
        }
        return false
    }


    SignInPanel()
    {
        const rememberMe = <FormControlLabel
        control={<Checkbox value="remember" color="primary" />}
        label={getSentence(18)}
        name="Remember me"
    />
        return (<this.CustomTabPanel value={this.state.tab} index={0}>
       
            <Box component="form" onSubmit={this.handleSignIn} noValidate sx={{ mt: 1 }}>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label={getSentence(23)}
                    name="email"
                    autoComplete="email"
                    autoFocus
                    defaultValue={this.state.mail}
                    onBlur={event => this.checkMail(event.target.value)}
                    error = {this.state.mailError}
                    helperText={this.state.mailHelperText}
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label={getSentence(22)}
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    error = {this.state.passwdError}
                    helperText={this.state.passwdHelperText}
                />
                {/*rememberMe*/}
                <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                >
                {getSentence(19)}
                </Button>
                <Grid container>
                    <Grid item >
                        <Link href="#" variant="body2" onClick={()=> this.recoveryPasswdDialog()}>
                            {getSentence(20)}
                        </Link>
                    </Grid>
                    <Grid item>
                        <Link href="#" variant="body2" onClick={()=>this.changeTab("", 1)}>
                        {getSentence(21)}
                        </Link>
                    </Grid>
                </Grid>
            </Box>
        </this.CustomTabPanel>)
  }


    SignUpPanel()
    {
        const acceptTOSText = <p>{getSentence(69)} <a href={'/TOS_pdf/' + getLanguage()}>{getSentence(70)}</a> {getSentence(71)} <a href='/legal'>{getSentence(72)}</a></p>

        return (<this.CustomTabPanel value={this.state.tab} index={1}>
            
            
            <Box component="form" onSubmit={this.handleSignUp} noValidate sx={{ mt: 1 }}>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    type="email"
                    label={getSentence(23)}
                    name="email"
                    autoComplete="email"
                    autoFocus
                    defaultValue={this.state.mail}
                    onBlur={event => this.checkMail(event.target.value)}
                    error = {this.state.mailError}
                    helperText={this.state.mailHelperText}
                />

                <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label={getSentence(22)}
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    error = {this.state.passwdError}
                    helperText={this.state.passwdHelperText}
                />

                <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="passwordCheck"
                    label={getSentence(22)}
                    type="password"
                    id="password"
                    autoComplete="current-passwordCheck"
                    error = {this.state.passwdError}
                    helperText={this.state.passwdHelperText}
                />

                
                
                <input type="checkbox" id="TOS" checked={this.state.TOSState} onChange={this.changeTOSState}/><label>{acceptTOSText}</label>
                {this.state.TOSHelperText}
                
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    {getSentence(15)}
                </Button>
                <Grid container>
                    <Grid item>
                        <Link href="#" variant="body2" onClick={()=>this.changeTab("", 0)}>
                        {getSentence(24)}
                        </Link>
                    </Grid>
                </Grid>
            </Box>
        </this.CustomTabPanel>)
  }

    CustomTabPanel(props) 
    {
        const { children, value, index, ...other } = props;
    
        return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
            <Box sx={{ p: 3 }}>
                <Typography>{children}</Typography>
            </Box>
            )}
        </div>
        );
    }

    a11yProps(index) 
    {
        return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
        };
    }

  

    render()
    {
        return (
            <Container component="main" maxWidth="xs">
                {this.state.errorMsg}
                <CssBaseline />
                <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
                >
                    {this.state.recoveryPasswdDialog}

                    <Tabs value={this.state.tab} onChange={this.changeTab} aria-label="basic tabs example">
                        <Tab label={getSentence(14)} {...this.a11yProps(0)}  />
                        <Tab label={getSentence(15)} {...this.a11yProps(1)} />
                    </Tabs>
                    
                    {this.SignInPanel()}
                    {this.SignUpPanel()}
        
                    
                </Box>
            </Container>
          );
    }
  
}